import React from 'react';
import { translate } from '../../../../Services/translation';
import CheckoutError from '../../other/CheckoutError';
import CheckoutCartSummary from './components/CheckoutCartSummary';
import CheckoutCartItems from './components/CheckoutCartItems';
import CheckoutCartCampaignCode from './components/CheckoutCartCampaignCode';
import CheckoutCartAddToCart from './components/CheckoutCartAddToCart';

const CheckoutCart = ({ checkout, cart }) => {
  const { errors } = checkout || {};

  return (
    <div className="checkout-section flex flex-col">
      <h2 className="heading-2 mb-4">{translate('checkout.cart.title')}</h2>
      <CheckoutError errors={errors?.cart} />
      <CheckoutCartAddToCart checkout={checkout} cart={cart} />
      <CheckoutCartItems checkout={checkout} cart={cart} />
      <CheckoutCartCampaignCode checkout={checkout} />
      <CheckoutCartSummary checkout={checkout} cart={cart} />
    </div>
  );
};

export default CheckoutCart;
